import './App.css';
import { Navbar } from './components/navbar/Navbar';
import { Page } from './components/page/Page';
import { Footer } from './components/footer/Footer';

function App() {
  return (
    <div>
      <Navbar />
      <Page />
      <Footer />
    </div>
  );
}
export default App;
